import authenticationModule from "./authenticationModule"

const LOGIN_STATE = "login"
const LOGIN_SUPPLY_STATE = "loginSupply"
const HOME_STATE = "r2.home"
const LOGIN_SUPPLY_STATE_ANALYSIS_MAP = "loginSupplyTripEdition"
const ANALYSIS_MAP_ROUTING_SESSION_STATE = "r2.analysisMap"
let isModalOpen = false

authenticationModule.config(["$stateProvider", function ($stateProvider) {
    $stateProvider.state(LOGIN_STATE, {
        data: {
            pageTitle: "{{'title.login' | translate}}"
        },
        url: "/login",
        template: "<nlg-authentication login-state='r2.home'></nlg-authentication>",
        requiresAuthentication: false
    }).state(LOGIN_SUPPLY_STATE, {
        data: {
            pageTitle: "{{'title.login' | translate}}"
        }, url: "/login/:token?tenant", resolve: {
            authentication: ["$stateParams", "loadingService", "authenticationService", "messagesModal", "$state", function ($stateParams, loadingService, authenticationService, messagesModal, $state) {
                return loadingService(authenticationService.authenticateSupplyWithToken($stateParams.token, $stateParams.tenant)
                    .then(() => $state.go(HOME_STATE))
                    .catch(() => messagesModal("dialog.warning", [{
                        keyBundle: "supply.embedded.tre.login.exception", parameters: []
                    }])).then(() => $state.go(LOGIN_STATE)))
            }]
        }, requiresAuthentication: false
    }).state(LOGIN_SUPPLY_STATE_ANALYSIS_MAP, {
        data: {
            pageTitle: "{{'title.login' | translate}}"
        }, url: "/login/:token/:routingSessionIdentifier?",
        resolve: {
            authentication: ["$stateParams", "loadingService", "authenticationService", "messagesModal", "$state", function ($stateParams, loadingService, authenticationService, messagesModal, $state) {
                return loadingService(
                    authenticationService.authenticateSupplyWithToken($stateParams.token)
                        .then(() => true)
                        .catch(() => {
                            return messagesModal("dialog.warning", [{
                                keyBundle: "supply.embedded.tre.login.exception", parameters: []
                            }]).then(() => {
                                $state.go(LOGIN_STATE)
                                return false
                            })
                        })
                ).then((isSuccess) => {
                    if (isSuccess) {
                        $state.go(ANALYSIS_MAP_ROUTING_SESSION_STATE, {
                            routingSessionIdentifier: $stateParams.routingSessionIdentifier
                        })
                    }
                })
            }]
        }, requiresAuthentication: false
    })
}])
    .config(["$urlRouterProvider", ($urlRouterProvider) => {
        $urlRouterProvider.otherwise("/login")
    }])
    .config(["$httpProvider", ($httpProvider) => {
        $httpProvider.interceptors.push(["$q", "$injector", ($q, $injector) => {
            return {
                responseError: (error) => {
                    if (error && (error.status === 401 || error.status === 403)) {
                        const $state = $injector.get("$state")
                        if ($state.current.name !== LOGIN_STATE) {
                            if ($state.current.data?.dontRedirectOnForbidden) {
                                //especifico para fluxo de lgpd - não redireciona página para login,
                                //devido a peculialidade de pesquisar em diversos artefatos
                            } else {
                                setTargetStateOn4xxError($state, error.status)

                                const supplyService = $injector.get("supplyService")
                                // Workaround para ciclo de digestão do localstorage, para remover o modo supply.
                                Promise.resolve(showAccessDeniedAndRedirectToLogin($state))
                                    .then(() => supplyService.inactivateSupplyMode())
                            }
                        }
                        return $q.reject(error)
                    }
                    return $q.reject(error)
                }
            }

            function showAccessDeniedAndRedirectToLogin($state) {
                if (isModalOpen) {
                    return
                }
                isModalOpen = true

                let messagesModal = $injector.get("messagesModal")
                return messagesModal("remoteExceptionHandler.AccessDenied", [{
                    keyBundle: "remoteExceptionHandler.AccessDenied.message"
                }]).then(() => {
                    isModalOpen = false
                    return $state.go(LOGIN_STATE)
                })
            }

            function setTargetStateOn4xxError($state, status) {
                let authenticationService = $injector.get("authenticationService")
                if (status === 403) {
                    if ($state.current.name === HOME_STATE) {
                        authenticationService.logOut()
                        return
                    }
                    return authenticationService.setTargetState(HOME_STATE)
                }
                authenticationService.logOut()
                return authenticationService.setTargetState($state.current, $state.current.params || $state.params)
            }
        }])
    }])
    .config(["$httpProvider", ($httpProvider) => {
        $httpProvider.interceptors.push(["$q", "$injector", ($q, $injector) => {
            let lastRenewTime = 0
            const FIVE_MINUTES = 5 * 60 * 1000

            return {
                request: (config) => {
                    let supplyService = $injector.get("supplyService")
                    let authenticationService = $injector.get("authenticationService")

                    if (shouldNotRenewSession(config, authenticationService)) {
                        return config
                    }

                    if (supplyService.isSupplyMode()) {
                        const now = Date.now()
                        if (now - lastRenewTime > FIVE_MINUTES) {
                            authenticationService.renewSupplySession()
                            lastRenewTime = now
                        }
                    }
                    return config
                }
            }

            function shouldNotRenewSession(config, authenticationService) {
                return !config.url.startsWith("/cockpit-gateway") || config.url.includes("/authentication/") || config.url.includes("/authorization") || !authenticationService.isAuthenticated()
            }
        }])
    }])
    .run(["$http", "authenticationService", "supplyService", ($http, authenticationService, supplyService) => {
        $http.defaults.headers.common["routing-session-identifier"] = () => {
            return supplyService.getRoutingSessionIdentifier() || undefined
        }
        $http.defaults.headers.common["user.token"] = $http.defaults.headers.common["usertoken"] = () => {
            return authenticationService.getUserToken()
        }
        $http.defaults.headers.common["tenant_id"] = () => {
            return authenticationService.getTenantId()
        }
    }])
